import { updateObject } from 'utils/updateObject'
import { List } from 'immutable'
import { ADD, REMOVE, SET_COUNTERS } from 'modules/Notifications/types'

const initialState = {
  notifications: [],
  counters: {
    recommendation: 0,
    audit: 0,
    benchmark: 0,
    ticket: 0,
  },
}

const addNotification = (state, { payload }) => {
  const updatedNotifications = List(state.notifications).push(payload)
  return updateObject(state, { notifications: updatedNotifications.toJS() })
}

const removeNotification = (state, { payload }) => {
  const current = List(state.notifications)
  const index = current.findIndex(({ UUID }) => UUID === payload.UUID)

  if (index === -1) {
    return state
  }

  return updateObject(state, { notifications: current.remove(index).toJS() })
}

const setCounters = (state, { payload }) =>
  updateObject(state, {
    counters: {
      ...state.counters,
      ...payload,
    },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD:
      return addNotification(state, action)
    case REMOVE:
      return removeNotification(state, action)
    case SET_COUNTERS:
      return setCounters(state, action)
    default:
      return state
  }
}

export default reducer
